import React, { type ReactElement } from 'react';

import { FormSuccessSVG } from '../../assets/images';
import { Description, H1 } from '../../ui/typography';
import { getContentByLanguage } from '../language';

import {
  RootLayout,
  RootPicture,
  RootSuccess,
  RootSuccessPicture,
  RootWrapper,
} from './SuccessSend.styles';
import { TLanguageCode } from '../../root.types';

export function SuccessSend({ languageCode }: { languageCode: TLanguageCode }): ReactElement {
  const { submittedPage } = getContentByLanguage(languageCode);

  return (
    <RootLayout>
      <RootSuccess>
        <RootWrapper>
          <H1>{submittedPage.title}</H1>
          <Description>
            {submittedPage.desription}
          </Description>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/Qe2mcMZ51wQ?si=CIlqnmNnh6GfP2Ln"
            title="Pushwoosh product demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            frameBorder="0"
            allowFullScreen
          />
        </RootWrapper>
      </RootSuccess>
      <RootSuccessPicture>
        <RootPicture>
          <FormSuccessSVG />
        </RootPicture>
      </RootSuccessPicture>
    </RootLayout>
  );
}
